import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  Button,
  Modal,
  Tooltip,
  Space,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import CustomButton from "../../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../../../../components/facilities/AccountFacility";
import styles from "../../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const ModifyCurrentAcc = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  // const isLienAllowed = Form.useWatch("lienAllowed", useForm);
  const [editingCharge, setEditingCharge] = useState(null);

  const [templateProdDetail, setTemplateProdDetail] = useState({});

  // CHARGES FORM REQURED VARIABLES
  const [chargeTableCount, setChargeTableCount] = useState(0);
  const [chargeTableSource, setChargeTableSource] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [productData, setProductData] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});
  const [interestCompoundingPeriodTypeOptions, setInterestCompoundingPeriodTypeOptions] = useState(
    []
  );
  const [interestPostingPeriodTypeOptions, setInterestPostingPeriodTypeOptions] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] = useState([]);
  const [interestCalculationDaysInYearTypeOptions, setInterestCalculationDaysInYearTypeOptions] =
    useState([]);
  const [lockinPeriodFrequencyTypeOptions, setLockinPeriodFrequencyTypeOptions] = useState([]);
  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);

  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [activationDate, setActivationDate] = useState([]);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [clientNonPersonConstitutionOptions, setClientNonPersonConstitutionOptions] = useState([]);
  const [clientNonPersonMainBusinessLineOptions, setClientNonPersonMainBusinessLineOptions] =
    useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [chargeList, setChargeList] = useState([]);
  const [isAddressEnabled, setIsAddressEnabled] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerInfo: null,
    customerAddressInfo: null,
  });

  useEffect(() => {
    getProductTemplate(state);
  }, []);

  const onChangeProduct = (productParam) => {
    getCustomerProductTemplate(templateProdDetail, productParam);
  };

  const getProductTemplate = (state) => {
    const params = {
      associations: "charges",
      staffInSelectedOfficeOnly: true,
      template: true,
    };

    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        setTemplateProdDetail(objList);
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          productId: objList.savingsProductId,
          fieldOfficerId: objList.fieldOfficerId,
          submittedOnDate: objList?.timeline
            ? dayjs(BOM.FormatArrayDate(objList?.timeline?.submittedOnDate))
            : objList?.timeline?.submittedOnDate,
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType: objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType: objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
          lienAllowed: objList?.lienAllowed,
          maxAllowedLienLimit: objList?.maxAllowedLienLimit,
          enforceMinRequiredBalance: objList?.enforceMinRequiredBalance,
          minRequiredBalance: objList?.minRequiredBalance,
          withdrawalFeeForTransfers: objList?.withdrawalFeeForTransfers,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach((element) => {
          tempInterestCalculationDaysInYearTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.assetAccountOptions?.forEach((element) => {
          tempAssetOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach((element) => {
          tempEquityOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach((element) => {
          tempExpenseOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach((element) => {
          tempIncomeOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach((element) => {
          tempLiabilityOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        const chargesLength = objList?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.id ? element?.id : "-",
            chargeId: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic value={element?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",

            feeInterval: element?.feeInterval?.value ? element?.feeInterval?.value : "-",
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setProductData(tempProducts);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(tempInterestCompoundingPeriodTypeOptions);
        setInterestPostingPeriodTypeOptions(tempInterestPostingPeriodTypeOptions);
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(tempInterestCalculationDaysInYearTypeOptions);
        setLockinPeriodFrequencyTypeOptions(tempLockinPeriodFrequencyTypeOptions);
        setChargeTableSource(tempCharges);

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        useForm.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions([...chargeForTableData]);
        setIsLoading(false);
      }
    });
  };

  const getCustomerProductTemplate = (customerParam, productParam) => {
    const params = {
      clientId: customerParam.clientId,
      productId: productParam,
    };

    const url = `${apiConfig.savingsAccounts}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];

        useForm.setFieldsValue({
          productId: objList.savingsProductId,
          fieldOfficerId: objList.fieldOfficerId,
          submittedOnDate: objList?.timeline
            ? dayjs(BOM.FormatArrayDate(objList?.timeline?.submittedOnDate))
            : objList?.timeline?.submittedOnDate,
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType: objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType: objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
          lienAllowed: objList?.lienAllowed,
          maxAllowedLienLimit: objList?.maxAllowedLienLimit,
          enforceMinRequiredBalance: objList?.enforceMinRequiredBalance,
          minRequiredBalance: objList?.minRequiredBalance,
          withdrawalFeeForTransfers: objList?.withdrawalFeeForTransfers,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach((element) => {
          tempInterestCalculationDaysInYearTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.assetAccountOptions?.forEach((element) => {
          tempAssetOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach((element) => {
          tempEquityOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach((element) => {
          tempExpenseOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach((element) => {
          tempIncomeOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach((element) => {
          tempLiabilityOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        const chargesLength = objList?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.id ? element?.id : "-",
            chargeId: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic value={element?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",

            feeInterval: element?.feeInterval?.value ? element?.feeInterval?.value : "-",
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setProductData(tempProducts);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(tempInterestCompoundingPeriodTypeOptions);
        setInterestPostingPeriodTypeOptions(tempInterestPostingPeriodTypeOptions);
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(tempInterestCalculationDaysInYearTypeOptions);
        setLockinPeriodFrequencyTypeOptions(tempLockinPeriodFrequencyTypeOptions);
        setChargeTableSource(tempCharges);

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        useForm.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions([...chargeForTableData]);
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-current-account", { state: state });
  }

  const handleChargeDelete = (key) => {
    console.log(key);
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleChargeEdit = (record) => {
    setEditingCharge(record);
    setIsModalOpen(true);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Date",
      dataIndex: "feeOnMonthDay",
    },
    {
      title: "Repayments Every",
      dataIndex: "feeInterval",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        chargeTableSource.length >= 1 ? (
          <Space>
            <Tooltip title="Edit Charge">
              <Button
                type="primary"
                icon={<EditOutlined />}
                shape="round"
                size="small"
                onClick={() => handleChargeEdit(record)}
                style={{ marginRight: 8 }}
                className="of-primaryBtnColor"
              />
            </Tooltip>
            <Tooltip title={`Remove Charge`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleChargeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          </Space>
        ) : null,
    },
  ];

  const onSubmit = (formValues) => {
    let tempChargeArray = [];

    chargeTableSource.forEach((element) => {
      const chargeObj = {
        chargeId: element.chargeId,
        amount: element.amountToUse,
      };

      if (element.feeOnMonthDay !== "-" && element.feeOnMonthDay) {
        const collectedOn = element.collectedOn?.toLowerCase().trim();

        if (collectedOn === "annual fee" || collectedOn === "monthly fee") {
          chargeObj.feeOnMonthDay = BOM.DateTimeWithoutYear(element.feeOnMonthDay, "only-date");
        } else if (collectedOn === "weekly fee" || collectedOn === "specified due date") {
          chargeObj.dueDate = BOM.DateTime(element.feeOnMonthDay, "only-date");
        } else {
          // fallback
          chargeObj.feeOnMonthDay = BOM.DateTimeWithoutYear(element.feeOnMonthDay, "only-date");
        }
      }

      tempChargeArray.push(chargeObj);
    });

    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.clientId = templateProdDetail.clientId;
    formValues.allowOverdraft = true;
    formValues.charges = tempChargeArray;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.monthDayFormat = "dd MMMM";
    formValues.locale = "en";

    delete formValues.chargeId;

    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateCurrentAccountMsg);
          navigate("/detail-current-account", {
            state: { ...state, statusValue: accountStatus.submittedAndPending },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-current-account", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  };

  const steps = ["modify"];
  return (
    <MainLayout isEnableRightSidebar={true} currentStep={steps[0]}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={labelConfig.editCurrentAccount} pageItems={[]} />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              isPenalty: false,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.currentAccountSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.product}
                  name={"productId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.product),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.product, "select")}
                    options={productData}
                    showSearch
                    onChange={onChangeProduct}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.accountOfficer} name="fieldOfficerId">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.accountOfficer, "select")}
                    options={fieldOfficerData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.currency}>
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={`${currencyData.name ? currencyData.name : ""}${
                      currencyData.code ? ` (${currencyData.code})` : " - "
                    }`}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.currency)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.decimalPlaces}>
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={`${currencyData.decimalPlaces ? currencyData.decimalPlaces : "-"}`}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.decimalPlaces)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.currencyInMultiplesOf}>
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={`${currencyData.inMultiplesOf ? currencyData.inMultiplesOf : " - "}`}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.currencyInMultiplesOf)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.submittedOn}
                  name="submittedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.submittedOn),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.submittedDate, "select")}
                    style={{ width: "100%", height: 35 }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.interestInformation}
                </Title>
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.norminalAnnualInterest}
                  name="nominalAnnualInterestRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.norminalAnnualInterest),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.norminalAnnualInterest)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestCompoundingPeriod}
                  name="interestCompoundingPeriodType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestCompoundingPeriod,
                      "select"
                    )}
                    options={interestCompoundingPeriodTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestPostingPeriod}
                  name="interestPostingPeriodType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestPostingPeriod,
                      "select"
                    )}
                    options={interestPostingPeriodTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestCalculatedUsing}
                  name="interestCalculationType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestCalculatedUsing,
                      "select"
                    )}
                    options={interestCalculationTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.daysInYear}
                  name="interestCalculationDaysInYearType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.daysInYear),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.daysInYear, "select")}
                    options={interestCalculationDaysInYearTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.additionalInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.minimumOpeningBalance}
                  name="minRequiredOpeningBalance"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumOpeningBalance)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.lockInPeriod} name="lockinPeriodFrequency">
                  <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={" "} name="lockinPeriodFrequencyType">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod, "select")}
                    options={lockinPeriodFrequencyTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              {/* <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.isLienAllowed} name="lienAllowed">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.isLienAllowed, "select")}
                    options={staticConfig.yesOrNoData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {isLienAllowed && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.maximumLienAmountLimit} name="maxAllowedLienLimit">
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.maximumLienAmountLimit)}
                    />
                  </Form.Item>
                </Col>
              )} */}

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.enforceMinimumBalance}
                  name="enforceMinRequiredBalance"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.enforceMinimumBalance,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.minimumBalance} name="minRequiredBalance">
                  <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumBalance)} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.applyWithdrawalFeeForTransfers}
                  name="withdrawalFeeForTransfers"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.applyWithdrawalFeeForTransfers,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.chargeInfo}
              </Title>
            </Divider>
            <ChargeModal
              formData={formData}
              stateProvinceIdData={stateProvinceIdData}
              countryIdData={countryIdData}
              addressTypeIdData={addressTypeIdData}
              isModalOpen={isModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              chargeData={chargesOptions}
              setChargeList={setChargeList}
              setChargeTableSource={setChargeTableSource}
              chargeTableSource={chargeTableSource}
              chargeList={chargeList}
              editingCharge={editingCharge}
              setEditingCharge={setEditingCharge}
              session={session}
            />

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {chargeTableSource.length > 1
                  ? labelConfig.selectedCharges
                  : labelConfig.selectedCharge}
              </Title>
            </Divider>

            {chargeTableSource?.length > 0 && (
              <Table
                columns={columns}
                dataSource={chargeTableSource}
                bordered
                pagination={{
                  position: "bottomCentre",
                  pageSize: "10",
                }}
              />
            )}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default ModifyCurrentAcc;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isModalOpen,
    chargeData,
    setIsModalOpen,
    editingCharge,
    setEditingCharge,
  } = props;

  const [useForm] = Form.useForm();

  // ✅ Prefill data when editing
  useEffect(() => {
    if (editingCharge && isModalOpen) {
      const collected = editingCharge.collectedOn?.toLowerCase()?.trim();
      let dateValue = null;

      if (collected === "annual fee" || collected === "monthly fee") {
        if (editingCharge.feeOnMonthDayRaw) {
          dateValue = editingCharge.feeOnMonthDayRaw;
        } else if (Array.isArray(editingCharge.feeOnMonthDay)) {
          const [month, day] = editingCharge.feeOnMonthDay;
          dateValue = dayjs(new Date(dayjs().year(), month - 1, day));
        } else if (editingCharge.feeOnMonthDay && editingCharge.feeOnMonthDay !== "-") {
          const parts = editingCharge.feeOnMonthDay.split(" ");
          if (parts.length === 2) {
            const [day, month] = parts;
            dateValue = dayjs(new Date(dayjs().year(), monthNameToIndex(month), day));
          }
        }
      }

      if (collected === "weekly fee" || collected === "specified due date") {
        if (editingCharge.dueDateRaw) {
          dateValue = editingCharge.dueDateRaw;
        } else if (Array.isArray(editingCharge.dueDate)) {
          const [month, day] = editingCharge.dueDate;
          dateValue = dayjs(new Date(dayjs().year(), month - 1, day));
        } else if (editingCharge.dueDate) {
          dateValue = dayjs(editingCharge.dueDate, "DD MMM YYYY");
        }
      }

      useForm.setFieldsValue({
        chargeId: editingCharge.id,
        name: editingCharge.name,
        type: editingCharge.type,
        collectedOn: editingCharge.collectedOn,
        amount: editingCharge.amountToUse,
        feeOnMonthDay: dateValue,
        feeInterval: editingCharge.feeInterval !== "-" ? editingCharge.feeInterval : "",
      });
    } else {
      useForm.resetFields();
    }
  }, [editingCharge, isModalOpen]);

  const monthNameToIndex = (monthName) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.indexOf(monthName);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditingCharge(null);
    useForm.resetFields();
  };

  // ✅ Save / Update handler
  const handleChargeSave = (formValues) => {
    const collected = formValues.collectedOn?.toLowerCase()?.trim();
    let rawDate = formValues.feeOnMonthDay ? dayjs(formValues.feeOnMonthDay) : null;

    const newCharge = {
      key: formValues.chargeId,
      id: formValues.chargeId,
      chargeId: formValues.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues.amount,
      amount: (
        <Statistic value={formValues.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
      ),
      feeInterval: formValues.feeInterval || "-",
    };

    if (rawDate) {
      if (collected === "annual fee" || collected === "monthly fee") {
        // store DD MMM for UI
        newCharge.feeOnMonthDay = rawDate.format("DD MMM");
        // keep full raw dayjs for re-edit
        newCharge.feeOnMonthDayRaw = rawDate;
      } else if (collected === "weekly fee" || collected === "specified due date") {
        // displayed on table
        newCharge.feeOnMonthDay = rawDate.format("DD MMM YYYY");
        // keep for modal re-edit
        newCharge.dueDateRaw = rawDate;
        newCharge.dueDate = rawDate.format("DD MMM YYYY");
      } else {
        newCharge.feeOnMonthDay = rawDate.format("DD MMM");
        newCharge.feeOnMonthDayRaw = rawDate;
      }
    } else {
      newCharge.feeOnMonthDay = "-";
    }

    // update or add
    if (editingCharge) {
      setChargeTableSource((prev) =>
        prev.map((item) => (item.id === editingCharge.id ? newCharge : item))
      );
      setEditingCharge(null);
    } else {
      const found = chargeTableSource.find((item) => item.chargeId === newCharge.chargeId);
      if (found) {
        BOM.AlertMsg(cnt.WARNING, labelConfig.noDuplicateCharges);
        return;
      }
      setChargeTableSource([...chargeTableSource, newCharge]);
    }

    useForm.resetFields();
    setIsModalOpen(false);
  };

  const handleSelectedCharge = (chargeId) => {
    const params = { template: "true" };
    const url = `${apiConfig.charges}/${chargeId}`;
    const body = { session, params };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, objList) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
        return;
      }

      let feeOnMonthDay = null;

      if (Array.isArray(objList.feeOnMonthDay)) {
        const [month, day] = objList.feeOnMonthDay;
        feeOnMonthDay = dayjs(new Date(dayjs().year(), month - 1, day));
      } else if (objList.feeOnMonthDay) {
        feeOnMonthDay = dayjs(objList.feeOnMonthDay, "DD MMM YYYY");
      }

      const collected = objList?.chargeTimeType?.value?.toLowerCase()?.trim();

      let dateValue = null;
      if (collected === "annual fee" || collected === "monthly fee") {
        dateValue = feeOnMonthDay;
      } else if (collected === "weekly fee" || collected === "specified due date") {
        dateValue = feeOnMonthDay;
      }

      useForm.setFieldsValue({
        chargeId: objList.id,
        name: objList.name,
        type: objList.chargeCalculationType.value,
        collectedOn: objList.chargeTimeType.value,
        amount: objList.amount,
        feeOnMonthDay: dateValue || null,
        feeInterval: objList.feeInterval || "",
      });

      setIsLoading(false);
    });
  };

  const disablePastDates = (current) => {
    return current && current < dayjs().startOf("day");
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        title={labelConfig.ChargeInformationSetup}
        open={isModalOpen}
        okText={editingCharge ? "Update" : "Add"}
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form form={useForm} layout="vertical" onFinish={handleChargeSave} name="address-info">
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeId"
                label="Charge Options"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.charge, "select")}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name="name">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name="type">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name="collectedOn">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.collectedOn)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name="amount">
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)} />
              </Form.Item>
            </Col>

            {/* ✅ Date now includes year */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.date} name="feeOnMonthDay">
                <DatePicker
                  format="DD MMM YYYY" // ✅ display full date format
                  disabledDate={disablePastDates}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.date, "select")}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.repaymentFrequency} name="feeInterval">
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.repaymentFrequency)} />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
